import { useState, useEffect } from 'react'

const CYCLE_MS = 3200

const RESTAURANT_TYPES = [
  { pre: 'Seu',  word: 'restaurante'  },
  { pre: 'Sua',  word: 'pizzaria'     },
  { pre: 'Seu',  word: 'barzinho'     },
  { pre: 'Sua',  word: 'churrascaria' },
  { pre: 'Sua',  word: 'sorveteria'   },
  { pre: 'Seu',  word: 'café'         },
  { pre: 'Sua',  word: 'lanchonete'   },
  { pre: 'Sua',  word: 'hamburgueria' },
  { pre: 'Seu',  word: 'food truck'   },
  { pre: 'Sua',  word: 'padaria'      },
  { pre: 'Seu',  word: 'bistrô'       },
  { pre: 'Sua',  word: 'doceria'      },
]

// ── Phone screens ─────────────────────────────────────────────────────────────
// Each screen has a real-screenshot src AND a React fallback component.
// Drop phone-home.jpg / phone-coupons.jpg / phone-menu.jpg into public/ and
// the real images will automatically replace the drawn fallbacks.

function ScreenHome() {
  return (
    <div className="absolute inset-0 bg-white flex flex-col overflow-hidden">
      {/* App header */}
      <div className="flex-shrink-0 flex items-center justify-between px-4 pt-3 pb-2.5 border-b border-neutral-100 bg-white">
        <div className="w-6 h-6 flex flex-col gap-[4px] justify-center">
          <div className="h-[2px] w-full bg-black rounded" />
          <div className="h-[2px] w-full bg-black rounded" />
          <div className="h-[2px] w-full bg-black rounded" />
        </div>
        <div className="w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center text-[18px]">🍽</div>
        <div className="w-6" />
      </div>
      {/* Greeting + status */}
      <div className="flex-shrink-0 flex items-start justify-between gap-2 px-3 pt-2 pb-1">
        <div className="text-[10px] font-bold leading-tight text-black">Boa tarde, Mofe</div>
        <div className="text-[8px] font-bold text-emerald-600 flex items-center gap-1 flex-shrink-0">
          <span className="w-1 h-1 rounded-full bg-emerald-500 inline-block" />
          Aberto · fecha às 22h
        </div>
      </div>
      {/* Banner — edge-to-edge, taller, carousel affordance */}
      <div
        className="flex-shrink-0 relative w-full overflow-hidden rounded-b-2xl"
        style={{ minHeight: 168, background: 'linear-gradient(135deg,#fff4ee,#ffe8d6)' }}
      >
        <div className="min-h-[168px] flex items-center justify-center text-[40px] pb-4">🍔</div>
        <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1">
          <span className="w-1.5 h-1.5 rounded-full bg-white shadow-sm" />
          <span className="w-1.5 h-1.5 rounded-full bg-white/40" />
          <span className="w-1.5 h-1.5 rounded-full bg-white/40" />
        </div>
      </div>
      {/* Address */}
      <div className="flex-shrink-0 px-3 pt-2">
        <div className="flex items-center gap-2 rounded-xl border border-neutral-200 bg-white px-2.5 py-2 min-h-[40px]">
          <svg className="w-3.5 h-3.5 flex-shrink-0 text-neutral-500" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path
              d="M12 11.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
              stroke="currentColor"
              strokeWidth="1.5"
            />
            <path
              d="M12 21s7-4.35 7-10a7 7 0 10-14 0c0 5.65 7 10 7 10z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
          </svg>
          <p className="flex-1 min-w-0 text-[9px] font-semibold text-neutral-800 leading-snug truncate">
            Rua João Francisco Zimmerman, 142 — Blumenau, SC
          </p>
          <span className="text-[8px] font-bold text-black flex-shrink-0 tracking-tight">Ver no mapa →</span>
        </div>
      </div>
      {/* Destaques */}
      <div className="px-3 pt-2 flex-1 overflow-hidden min-h-0">
        <div className="text-[11px] font-bold mb-2">Novidades</div>
        <div className="grid grid-cols-2 gap-2">
          {[['X Burger','R$21','#fff4ee','🍔'],['Coke','R$10','#f0f9ff','🥤']].map(([n,p,bg,e]) => (
            <div key={n} className="rounded-xl border border-neutral-100 overflow-hidden bg-white">
              <div className="h-16 flex items-center justify-center text-[28px]" style={{ background: bg }}>{e}</div>
              <div className="px-2 py-1.5">
                <div className="text-[10px] font-bold">{n}</div>
                <div className="text-[10px] font-extrabold mt-0.5">{p}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Checkout bar */}
      <div className="flex-shrink-0 mx-3 mb-3 mt-2 bg-[#141410] rounded-2xl px-4 py-3 flex items-center justify-between">
        <span className="text-white text-[11px] font-bold">R$21,50</span>
        <span className="text-white text-[11px] font-bold">Continuar →</span>
      </div>
    </div>
  )
}

function ScreenCoupons() {
  return (
    <div className="absolute inset-0 bg-white flex flex-col overflow-hidden">
      <div className="flex-shrink-0 flex items-center justify-between px-4 pt-4 pb-3 border-b border-neutral-100">
        <div className="w-6 h-6 flex flex-col gap-[4px] justify-center">
          <div className="h-[2px] w-full bg-black rounded" />
          <div className="h-[2px] w-full bg-black rounded" />
          <div className="h-[2px] w-full bg-black rounded" />
        </div>
        <div className="w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center text-[18px]">🍽</div>
        <div className="w-6" />
      </div>
      {/* Tabs */}
      <div className="flex-shrink-0 flex gap-2 px-3 pt-3 pb-2">
        <div className="flex-1 text-center py-2 rounded-xl bg-black text-white text-[10px] font-bold">Disponíveis</div>
        <div className="flex-1 text-center py-2 rounded-xl bg-neutral-100 text-neutral-500 text-[10px] font-bold">Utilizados</div>
      </div>
      {/* Coupon cards */}
      <div className="flex-1 px-3 flex flex-col gap-2.5 overflow-hidden pt-1">
        {[
          { value: 'R$ 10,00 OFF', code: 'ENTREGA GRATIS', min: 'Pedido mínimo: R$ 50,00', extra: null },
          { value: '20% OFF', code: 'PAI20', min: 'Pedido mínimo: R$ 100,00', extra: 'Válido até 11 de mai. de 2026' },
        ].map((c) => (
          <div key={c.code} className="rounded-2xl border border-neutral-200 bg-neutral-50 px-4 py-3" style={{ borderTop: '4px solid #141410' }}>
            <div className="text-[14px] font-black mb-0.5">{c.value}</div>
            <div className="text-[10px] font-bold text-neutral-500 mb-1">{c.code}</div>
            <div className="text-[9px] text-neutral-400">{c.min}{c.extra && <span className="ml-2">{c.extra}</span>}</div>
          </div>
        ))}
      </div>
      <div className="flex-shrink-0 mx-3 mb-3 mt-2 bg-[#141410] rounded-2xl px-4 py-3 flex items-center justify-between">
        <span className="text-white text-[11px] font-bold">R$21,50</span>
        <span className="text-white text-[11px] font-bold">Continuar →</span>
      </div>
    </div>
  )
}

const MENU_SECTIONS = [
  {
    title: 'Burgers',
    items: [
      { name: 'X burger', desc: 'Pão, carne, queijo e molho da casa', price: 'R$ 21,00', bg: '#fff4ee', emoji: '🍔' },
      { name: 'Cheese bacon', desc: 'Bacon crocante e cheddar', price: 'R$ 26,00', bg: '#fff7ed', emoji: '🥓' },
      { name: 'Veggie smash', desc: 'Hambúrguer de grão-de-bico', price: 'R$ 23,00', bg: '#f0fdf4', emoji: '🥬' },
    ],
  },
  {
    title: 'Drinks',
    items: [
      { name: 'Coke', desc: 'Coca gelada 350ml', price: 'R$ 10,00', bg: '#f0f9ff', emoji: '🥤' },
      { name: 'Guaraná', desc: 'Lata 350ml', price: 'R$ 9,00', bg: '#ecfdf5', emoji: '🧃' },
      { name: 'Suco natural', desc: 'Laranja ou limão 300ml', price: 'R$ 12,00', bg: '#fffbeb', emoji: '🍊' },
    ],
  },
  {
    title: 'Desserts',
    items: [
      { name: 'Brownie', desc: 'Com sorvete de caramelo', price: 'R$ 18,00', bg: '#fdf4f8', emoji: '🍫' },
      { name: 'Pudim', desc: 'Calda de caramelo salgado', price: 'R$ 14,00', bg: '#faf5ff', emoji: '🍮' },
    ],
  },
  {
    title: 'Sides',
    items: [
      { name: 'Batata frita', desc: 'Porção média com aioli', price: 'R$ 16,00', bg: '#fffbeb', emoji: '🍟' },
      { name: 'Onion rings', desc: 'Empanados crocantes', price: 'R$ 15,00', bg: '#fef3c7', emoji: '🧅' },
    ],
  },
]

const MENU_CHIPS = [
  ['BURGERS', true],
  ['DRINKS', false],
  ['DESSERTS', false],
  ['SIDES', false],
  ['COMBOS', false],
]

function ScreenMenu() {
  return (
    <div className="absolute inset-0 bg-white flex flex-col overflow-hidden">
      <div className="flex-shrink-0 flex items-center justify-between px-4 pt-4 pb-3 border-b border-neutral-100">
        <div className="w-6 h-6 flex flex-col gap-[4px] justify-center">
          <div className="h-[2px] w-full bg-black rounded" />
          <div className="h-[2px] w-full bg-black rounded" />
          <div className="h-[2px] w-full bg-black rounded" />
        </div>
        <div className="w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center text-[18px]">🍽</div>
        <div className="w-6" />
      </div>
      {/* Category chips */}
      <div className="flex-shrink-0 flex items-center gap-2 px-3 py-2.5 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:w-0 [&::-webkit-scrollbar]:h-0">
        <div className="w-7 h-7 flex-shrink-0 rounded-full border border-neutral-200 flex items-center justify-center">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="5" cy="5" r="3.5" stroke="#9ca3af" strokeWidth="1.2"/><path d="M7.5 7.5L10 10" stroke="#9ca3af" strokeWidth="1.2" strokeLinecap="round"/></svg>
        </div>
        {MENU_CHIPS.map(([l, a]) => (
          <span key={l} className={`text-[9px] font-bold px-3 py-1.5 rounded-full border flex-shrink-0 ${a ? 'bg-black text-white border-black' : 'bg-white text-neutral-400 border-neutral-200'}`}>{l}</span>
        ))}
      </div>
      {/* List */}
      <div className="flex-1 px-3 overflow-y-auto overflow-x-hidden flex flex-col gap-0 min-h-0">
        {MENU_SECTIONS.map((section) => (
          <div key={section.title}>
            <div className="text-[12px] font-black pt-1 pb-1.5">{section.title}</div>
            {section.items.map((item) => (
              <div key={item.name} className="flex items-center gap-3 p-3 rounded-2xl border border-neutral-100 bg-white mb-2">
                <div className="flex-1 min-w-0">
                  <div className="text-[11px] font-bold mb-0.5">{item.name}</div>
                  <div className="text-[9px] text-neutral-400 mb-1 line-clamp-2">{item.desc}</div>
                  <div className="text-[11px] font-extrabold">{item.price}</div>
                </div>
                <div className="w-14 h-14 rounded-xl flex-shrink-0 flex items-center justify-center text-[24px]" style={{ background: item.bg }}>
                  {item.emoji}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="flex-shrink-0 mx-3 mb-3 bg-[#141410] rounded-2xl px-4 py-3 flex items-center justify-between">
        <span className="text-white text-[11px] font-bold">R$21,50</span>
        <span className="text-white text-[11px] font-bold">Continuar →</span>
      </div>
    </div>
  )
}

const SCREENS = [
  { id: 'home',    src: '/phone-home.jpg',    Fallback: ScreenHome },
  { id: 'coupons', src: '/phone-coupons.jpg', Fallback: ScreenCoupons },
  { id: 'menu',    src: '/phone-menu.jpg',    Fallback: ScreenMenu },
]

// ── Phone demo ────────────────────────────────────────────────────────────────

function PhoneDemo() {
  const [active, setActive]   = useState(0)
  const [visible, setVisible] = useState(true)

  const goTo = (i) => {
    setVisible(false)
    setTimeout(() => { setActive(i); setVisible(true) }, 280)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      goTo((active + 1) % SCREENS.length)
    }, CYCLE_MS)
    return () => clearInterval(interval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active])

  const { src, Fallback } = SCREENS[active]

  return (
    <div className="flex flex-col items-center gap-4">
      {/* iPhone shell */}
      <div style={{
        position: 'relative',
        width: 256,
        background: 'linear-gradient(160deg, #2e2e2e 0%, #1a1a1a 100%)',
        borderRadius: 56,
        padding: '14px 10px',
        boxShadow:
          'inset 0 0 0 1px rgba(255,255,255,0.08), ' +
          '0 50px 100px rgba(0,0,0,0.22), ' +
          '0 20px 40px rgba(0,0,0,0.14), ' +
          '0 0 0 1px rgba(0,0,0,0.5)',
      }}>

        {/* Left buttons: silent switch + vol up + vol down */}
        <div style={{ position:'absolute', left:-3, top:68,  width:3, height:22, background:'#2a2a2a', borderRadius:'3px 0 0 3px' }}/>
        <div style={{ position:'absolute', left:-3, top:104, width:3, height:34, background:'#2a2a2a', borderRadius:'3px 0 0 3px' }}/>
        <div style={{ position:'absolute', left:-3, top:146, width:3, height:34, background:'#2a2a2a', borderRadius:'3px 0 0 3px' }}/>
        {/* Right button: power */}
        <div style={{ position:'absolute', right:-3, top:108, width:3, height:56, background:'#2a2a2a', borderRadius:'0 3px 3px 0' }}/>

        {/* Screen */}
        <div style={{ borderRadius:44, overflow:'hidden', background:'#111', position:'relative' }}>

          <div style={{ position:'relative', height:490, overflow:'hidden' }}>
            {/* React fallback — always rendered, covered by real image when available */}
            <div style={{
              position:'absolute', inset:0,
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(6px)',
              transition: 'opacity 0.3s ease, transform 0.3s ease',
            }}>
              <Fallback />
            </div>
            {/* Real screenshot — overlays fallback once the file exists in /public */}
            <img
              key={src}
              src={src}
              alt=""
              onError={e => { e.currentTarget.style.display = 'none' }}
              style={{
                position: 'absolute',
                top: 0, left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'top',
                opacity: visible ? 1 : 0,
                transform: visible ? 'scale(1)' : 'scale(0.98)',
                transition: 'opacity 0.3s ease, transform 0.3s ease',
              }}
            />
          </div>

          {/* Home indicator */}
          <div style={{ height:28, background:'#fff', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <div style={{ width:100, height:4, background:'rgba(0,0,0,0.18)', borderRadius:4 }}/>
          </div>
        </div>
      </div>

      {/* Dot nav */}
      <div className="flex items-center gap-1.5">
        {SCREENS.map((s, i) => (
          <button
            key={s.id}
            onClick={() => goTo(i)}
            className={`h-1.5 rounded-full transition-all duration-300 border-none cursor-pointer p-0 ${i === active ? 'w-5 bg-[#141410]' : 'w-1.5 bg-neutral-300'}`}
          />
        ))}
      </div>
    </div>
  )
}

// ── Floating cards ────────────────────────────────────────────────────────────

function CardNewOrder() {
  return (
    <div style={{
      background: 'white',
      borderRadius: 16,
      padding: '11px 14px',
      boxShadow: '0 12px 32px rgba(0,0,0,0.10), 0 2px 8px rgba(0,0,0,0.06)',
      border: '1px solid rgba(0,0,0,0.06)',
      minWidth: 178,
    }}>
      <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:7 }}>
        <span style={{ position:'relative', display:'inline-flex', width:8, height:8, flexShrink:0 }}>
          <span style={{ position:'absolute', inset:0, borderRadius:'50%', background:'#22c55e', opacity:0.45, animation:'ping 1.2s cubic-bezier(0,0,0.2,1) infinite' }} />
          <span style={{ position:'relative', width:8, height:8, borderRadius:'50%', background:'#22c55e' }} />
        </span>
        <span style={{ fontSize:10, fontWeight:700, color:'#15803d' }}>Novo pedido</span>
        <span style={{ marginLeft:'auto', fontSize:9, color:'#9ca3af' }}>agora</span>
      </div>
      <div style={{ fontSize:13, fontWeight:800, color:'#111', marginBottom:2 }}>Mesa 4 · R$84,00</div>
      <div style={{ fontSize:10, color:'#9ca3af' }}>Carbonara · Caipirinha × 2</div>
    </div>
  )
}

function CardRevenue() {
  return (
    <div style={{
      background: '#0E0E0C',
      borderRadius: 16,
      padding: '11px 16px',
      boxShadow: '0 12px 32px rgba(0,0,0,0.22), 0 2px 8px rgba(0,0,0,0.12)',
      minWidth: 140,
    }}>
      <div style={{ fontSize:9, fontWeight:600, color:'rgba(255,255,255,0.35)', textTransform:'uppercase', letterSpacing:1, marginBottom:4 }}>Hoje</div>
      <div style={{ fontSize:22, fontWeight:900, color:'white', letterSpacing:-0.5, lineHeight:1, marginBottom:5 }}>R$2.340</div>
      <div style={{ display:'flex', alignItems:'center', gap:3 }}>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M2 7.5L5 2.5L8 7.5" stroke="#22c55e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span style={{ fontSize:10, color:'#22c55e', fontWeight:600 }}>+18% vs ontem</span>
      </div>
    </div>
  )
}

// ── Section ───────────────────────────────────────────────────────────────────

export default function Hero() {
  const [typeIdx, setTypeIdx]       = useState(0)
  const [wordVisible, setWordVisible] = useState(true)

  useEffect(() => {
    const t = setInterval(() => {
      setWordVisible(false)
      setTimeout(() => {
        setTypeIdx(i => (i + 1) % RESTAURANT_TYPES.length)
        setWordVisible(true)
      }, 220)
    }, 2400)
    return () => clearInterval(t)
  }, [])

  const { pre, word } = RESTAURANT_TYPES[typeIdx]

  return (
    <section
      className="px-5 pt-14 pb-16 sm:px-8 lg:px-16 lg:pt-20 lg:pb-24 overflow-hidden"
      style={{
        background: 'radial-gradient(ellipse 55% 70% at 85% 50%, rgba(255,185,60,0.07) 0%, transparent 65%), #FAFAF8',
      }}
    >
      <div className="max-w-[1140px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 lg:items-center">

          {/* Copy */}
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-2 border border-neutral-200 bg-white rounded-full px-3.5 py-1.5 text-[12px] font-semibold text-neutral-500 mb-7 shadow-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 flex-shrink-0" />
              30 dias grátis · Sem cartão de crédito
            </div>

            <h1 className="text-[38px] sm:text-[50px] lg:text-[62px] font-black tracking-[-1.5px] sm:tracking-[-2px] lg:tracking-[-2.8px] leading-[1.12] text-black mb-5">
              {/* Line 1: cycling restaurant type */}
              <span className="block overflow-hidden" style={{ height: '1.12em' }}>
                <span
                  style={{
                    display: 'block',
                    opacity: wordVisible ? 1 : 0,
                    transform: wordVisible ? 'translateY(0)' : 'translateY(40%)',
                    transition: 'opacity 0.22s ease, transform 0.22s ease',
                  }}
                >
                  {pre}{' '}
                  <span style={{ color: '#e07b00' }}>{word}</span>.
                </span>
              </span>
              {/* Lines 2–3: static */}
              <span className="block">Seu site.</span>
              <span style={{ position: 'relative', display: 'inline-block' }}>
                Suas vendas.
                <svg style={{ position:'absolute', bottom:-5, left:0, width:'100%', height:6, overflow:'visible' }} viewBox="0 0 200 6" preserveAspectRatio="none">
                  <path d="M0 5 Q50 0 100 4 Q150 8 200 3" stroke="#f59e0b" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
                </svg>
              </span>
            </h1>

            <p className="text-[16px] lg:text-[17px] text-neutral-500 leading-[1.72] max-w-[480px] mb-8">
              Crie o site e cardápio digital do seu restaurante — com pedidos de mesa, delivery e retirada. Teste tudo, grátis, por 30 dias.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-7">
              <a
                href="#testar-gratis"
                className="inline-flex items-center justify-center gap-2 bg-[#141410] text-white px-7 py-[15px] rounded-full text-[15px] font-bold no-underline hover:bg-[#2c2c28] active:scale-[0.98] transition-all"
              >
                Começar 30 dias grátis →
              </a>
              <a
                href="#precos"
                className="inline-flex items-center justify-center bg-transparent text-black px-7 py-[15px] rounded-full text-[15px] font-semibold no-underline border border-neutral-200 hover:border-neutral-400 transition-colors"
              >
                Ver planos
              </a>
            </div>

            <div className="flex flex-wrap gap-x-5 gap-y-2">
              {['Sem cartão de crédito', 'Pronto em menos de 24 horas', 'Cancele quando quiser'].map((item) => (
                <div key={item} className="flex items-center gap-1.5 text-[12px] text-neutral-400">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6l2.5 2.5L10 3.5" stroke="#22c55e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {item}
                </div>
              ))}
            </div>
          </div>

          {/* Phone + floating cards */}
          <div className="flex justify-center lg:justify-end flex-shrink-0">
            <div style={{ position:'relative', marginLeft: 0, paddingLeft: 16, paddingRight: 16, paddingTop: 40, paddingBottom: 40 }}>

              {/* Soft glow behind phone */}
              <div style={{
                position:'absolute', inset:0,
                background:'radial-gradient(ellipse at center, rgba(255,185,60,0.10) 0%, transparent 68%)',
                borderRadius:'50%',
                transform:'scale(1.4)',
                pointerEvents:'none',
              }} />

              {/* Order card — top left */}
              <div className="hidden lg:block" style={{ position:'absolute', top:16, left:-158, zIndex:10, transform:'rotate(-2deg)' }}>
                <CardNewOrder />
              </div>

              {/* Revenue card — bottom right */}
              <div className="hidden lg:block" style={{ position:'absolute', bottom:24, right:-130, zIndex:10, transform:'rotate(2deg)' }}>
                <CardRevenue />
              </div>

              <PhoneDemo />
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}
